import { memo } from 'react';
import { CustomImage } from '../CustomImage';

interface CoverImageProps {
  src?: string | null;
  alt: string;
  aspectRatio?: string;
  className?: string;
  imgClassName?: string;
  placeholderClassName?: string;
}

const CoverImage = memo(
  ({
    src,
    alt,
    aspectRatio = '359/206',
    className = '',
    imgClassName = 'h-full w-full object-cover',
    placeholderClassName = 'h-full w-full bg-primary-100',
  }: CoverImageProps) => {
    return (
      <div className={className || undefined} style={{ aspectRatio }}>
        {src ? <CustomImage src={src} alt={alt} className={imgClassName} /> : <div className={placeholderClassName} />}
      </div>
    );
  },
);

CoverImage.displayName = 'CoverImage';

export default CoverImage;
